__turbopack_context__.v({
  "compact": "styles-module-scss-module__H8kKZW__compact",
  "description": "styles-module-scss-module__H8kKZW__description",
  "metaOnlyRow": "styles-module-scss-module__H8kKZW__metaOnlyRow",
  "optionTitle": "styles-module-scss-module__H8kKZW__optionTitle",
  "price": "styles-module-scss-module__H8kKZW__price",
  "quantity": "styles-module-scss-module__H8kKZW__quantity",
  "separator": "styles-module-scss-module__H8kKZW__separator",
  "serviceItem": "styles-module-scss-module__H8kKZW__serviceItem",
  "serviceList": "styles-module-scss-module__H8kKZW__serviceList",
  "serviceMeta": "styles-module-scss-module__H8kKZW__serviceMeta",
  "serviceName": "styles-module-scss-module__H8kKZW__serviceName",
  "serviceRow": "styles-module-scss-module__H8kKZW__serviceRow",
  "serviceTitle": "styles-module-scss-module__H8kKZW__serviceTitle",
  "summary": "styles-module-scss-module__H8kKZW__summary",
  "totalRow": "styles-module-scss-module__H8kKZW__totalRow",
  "visuallyHidden": "styles-module-scss-module__H8kKZW__visuallyHidden",
  "withDescriptions": "styles-module-scss-module__H8kKZW__withDescriptions",
});
